import React, {useState, useEffect, useCallback} from "react";
import Loading from "../../icons/Loading";

import {
  ON_CART_UPDATE,
  FREE, ACTION_RESET_SHIPPING, ON_SHIPPING_METHOD_SELECT,
} from "../../globals";

const CartSidebar = () => {

  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState(null);
  const [selectedMethod, SetSelectedMethod] = useState(false);

  const bindActions = useCallback(() => {
    window.addEventListener(ON_CART_UPDATE, (e) => {
      const data = e.data;
      setCart(data);
    });

    window.addEventListener(ON_SHIPPING_METHOD_SELECT, (e) => {
      SetSelectedMethod(true)
    });

  }, []);

  useEffect(() => {
    if (cart) {
      setLoading(false);
    }
  }, [cart])

  useEffect(() => {
    bindActions();
  });

  if (loading) {
    return <div className="card-cart">
      <div className="card-cart__loading">
        <Loading/>
      </div>
    </div>
  }

  return <div className="card-cart">
    <h3 className="card-cart__title">Order Summary</h3>
    <table>
      <tbody>
      {/* Subtotal */}
      <tr className="card-cart__border-b">
        <th>
          Subtotal ({cart.item_records.reduce((total, item) => total + item.quantity, 0)}{" "}items, Ex. GST)
        </th>
        <th>{cart.items_total}</th>
      </tr>

      {/* Deductions */}
      {cart.deductions.map((modifier) => {
        if (modifier.amount === "$0.00") {
          return null;
        }

        if (!selectedMethod && modifier.title === 'Shipping') {
          return null;
        }

        return (
          <tr
            key={`deductions_${modifier.id}`}
            className="card-cart__border-0"
          >
            <th>{modifier.title}</th>
            <th>-{modifier.amount}</th>
          </tr>
        );
      })}

      {/* Additions */}
      {cart.additions.map((modifier) => {
        if (cart.tax_exempted === 1 && modifier.title === "GST") {
          return null;
        }

        if (!selectedMethod && modifier.title === 'Shipping') {
          return null;
        }

        return <tr
          key={`additions_${modifier.id}`}
          className="card-cart__border-0"
        >
          <th>{modifier.title}</th>
          <th>
            {modifier.free
              ? "FREE"
              : modifier.amount}
          </th>
        </tr>;
      })}

      {/* Total */}
      <tr className="card-cart__border-b">
        <th>Total {cart.tax_exempted ? "": "(Incl. GST)" }</th>
        <th>{cart.total}</th>
      </tr>
      </tbody>
    </table>
  </div>
};

export default CartSidebar;
